import { DrmInformation } from "@/types/drmInformation";
import { useNavigate, useLocation } from "react-router-dom";
import { useDrmInformationSearch } from "@/stores/drmInformationSearch";
import * as Common from "@/utils/common";
import React from "react";
import {CustomMarkdown} from "@/components/CustomMarkdown";

export const ResultItem = ( { drmInformation, index }: { drmInformation: DrmInformation, index: number } ) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setBackPage } = useDrmInformationSearch();
  const onClickDetail = () => {
    // 現在の検索条件（クエリパラメータ）を含めてbackPageに保存
    setBackPage(`/information${location.search}`);
    navigate(`/information/${drmInformation.id}`);
  };
  const newFlag = () => {
    const releaseDate = new Date(drmInformation.release_date)
    const targetDate = new Date()
    targetDate.setHours(0, 0, 0, 0);
    targetDate.setDate(targetDate.getDate() - 14);
    return targetDate <= releaseDate;
  };

  return (
    <div
      className="drmInformation-search-result-item"
      key={index}
      onClick={onClickDetail}
    >
      <div className="uk-flex uk-flex-between">
        <div className="uk-flex">
          <p className="uk-text-medium-s uk-text-bold">{drmInformation.display_num}</p>
          <p className="uk-text-medium-s uk-text-bold margin-left-24">
            {drmInformation.title}
          </p>
        </div>
        {newFlag() && <div className="new-label">NEW</div>}
      </div>
      <div className="description">
        <p className="uk-text-default description-question">
          <CustomMarkdown content={drmInformation?.body}/>
        </p>
      </div>
      <div className="uk-flex uk-flex-between uk-margin-top margin-left-32">
        <div className="uk-flex">
          <div className="uk-flex uk-flex-middle width-175">
            <p className="tag-dark">管理番号</p>
            <p className="uk-text-default margin-left-16">{Common.controlNum(drmInformation.control_number)}</p>
          </div>
          <div className="uk-flex uk-flex-middle width-175">
            <p className="tag-dark">公開日</p>
            <p className="uk-text-default margin-left-27">{drmInformation.release_date}</p>
          </div>
        </div>
        <div className="uk-flex uk-flex-wrap gap-10 uk-margin-small-right">
          <p className="tag-light">{drmInformation.type.value}</p>
        </div>
      </div>
    </div>
  );
};